/**
 * Pending user preference write helpers.
 *
 * Keeps the debounce queue bookkeeping testable outside the React hook that
 * persists current-user UI preferences.
 */
export function takePendingPreferenceWrite({ key, pendingValueRef, hasPendingRef, timerRef }) {
  if (!key || !hasPendingRef?.current) return null;
  if (timerRef?.current) {
    clearTimeout(timerRef.current);
    timerRef.current = null;
  }

  const value = pendingValueRef.current;
  hasPendingRef.current = false;
  return { key, value };
}
